const resources = {
    freeShipping: 'Expédition gratuite'
};

export default function getResource(label) {
    return resources[label];
}
